import Layout from "../../../../shared/components/Layout";
import Loading from "../../../../shared/components/Loading";
import ManageSubscriptionModal from "../../modals/ManageSubscriptionModal";
import ChangePasswordModal from "../../modals/ChangePasswordModal";
import UserInfoModal from "../../modals/UserInfoModal";
import UpgradeAction from "@/shared/components/UpgradeAction";
import {PaymentAPI} from "@/apis/PaymentAPI";
import PaymentMethodsModal from "@/modules/account/modals/PaymentMethodsModal";

export default {
    name: "Account.vue",
    data() {
        return {
            isCardModalActive: false,
            showSubscriptionModal: false,
            accountFormData: {},
            paymentMethod: {},
            loading: {
                paymentMethods: false,
                subscriptions: false,
            },
        }
    },
    components: {Layout, Loading, UpgradeAction},
    async mounted() {
        this.loading.paymentMethods = true;
        await this.$store.commit('account/loading');


        await this.loadPaymentMethods();
        await this.$store.dispatch('account/updateSubscriptionDetails');
        await this.$store.commit('account/loaded');
        await this.$store.dispatch('account/getCredits');

        if (this.$route.query.trigger === 'updateCard') {
            this.showPaymentMethodModal();
        }
        SFAnalytics.track('Dashboard Account Page Viewed');
        // this.subscriptionDetails = await PaymentAPI.getSubscriptionDetails();
    },
    methods: {
        async loadPaymentMethods() {
            try {
                this.paymentMethod = await PaymentAPI.getPaymentMethods();
            } catch (e) {

            } finally {
                this.loading.paymentMethods = false;
            }
        },
        showSubscription() {
            this.$buefy.modal.open({
                parent: this,
                component: ManageSubscriptionModal,
                customClass: " small-modal"
            })
        },
        showChangePasswordModal() {
            this.$buefy.modal.open({
                parent: this,
                component: ChangePasswordModal,
                customClass: " small-modal"
            })
        },
        showChangeUserInfoModal() {
            this.$buefy.modal.open({
                parent: this,
                component: UserInfoModal,
                customClass: " small-modal",
                props: {
                    data: this.userInfo
                },
                events: {
                    close: () => {
                        this.$store.dispatch('updateUserData');
                    }
                }
            })
        },
        showPaymentMethodModal() {
            this.$buefy.modal.open({
                parent: this,
                component: PaymentMethodsModal,
                customClass: " small-modal",
                props: {},
                events: {
                    close: async () => {
                        await this.loadPaymentMethods();
                    }
                }
            })
        },
    },
    computed: {
        subscriptionDetails() {
            return this.$store.state.account && this.$store.state.account.subscriptionDetails;
        },
        subscriptionsLoading() {
            return this.$store.state.account && this.$store.state.account.loading;
        },
        userInfo() {
            return this.$store.state.user.info.user || {};
        },
        SUBSCRIPTION_STATUS() {
            return PaymentAPI.SUBSCRIPTION_STATUS;
        }
    }
}
